var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import debounce from 'debounce';
import { Button } from '@signicat/designi/components/buttons';
import { Flex } from '@signicat/designi/components/layout';
import { TextField, Select } from '@signicat/designi/components/inputs';
import { media } from '@signicat/designi/helpers/responsive';
import { t } from "../helpers/i18n";
var SearchFlex = styled(Flex).withConfig({
  displayName: "Filters__SearchFlex",
  componentId: "sc-1ui79yf-0"
})([""]);
var StyledFlex = styled(Flex).withConfig({
  displayName: "Filters__StyledFlex",
  componentId: "sc-1ui79yf-1"
})(["margin-top:60px;margin-bottom:40px;justify-content:space-between;", ""], media.css.mobile.and('down')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex-direction: column;\n    & > ", " {\n      margin-top: 16px;\n      justify-content: stretch;\n      align-items: stretch;\n      flex-direction: column;\n    }\n  "])), SearchFlex));
var predefinedFilters = [{
  id: 'all',
  status: null,
  label: 'filters_label_all'
}, {
  id: 'draft',
  status: ['draft'],
  label: 'filters_label_drafted'
}, {
  id: 'waiting',
  status: ['partially_signed', 'sent'],
  label: 'filters_label_waiting'
}, {
  id: 'signed',
  status: ['signed'],
  label: 'filters_label_signed'
}, {
  id: 'deleted',
  status: ['deleted'],
  label: 'filters_label_deleted'
}, {
  id: 'queued_for_removal',
  status: ['signed', 'draft'],
  label: 'filters_label_removal'
}, {
  id: 'myorders',
  status: null,
  label: 'filters_label_myorders'
}];
var Filters = function Filters(props) {
  var setFilters = props.setFilters;
  var isLoading = useSelector(function (state) {
    return state.orders.isLoading;
  });
  var filter = useSelector(function (state) {
    return state.orders.filter;
  });
  var _useState = useState(filter),
    _useState2 = _slicedToArray(_useState, 2),
    activePredefinedFilter = _useState2[0],
    setActivePredefinedFilter = _useState2[1];
  var searchHandler = useCallback(debounce(function (filter) {
    setFilters([{
      id: filter.id,
      status: filter.status,
      searchTerm: filter.searchTerm
    }]);
  }, 700), []);
  var handleSearchInputChange = function handleSearchInputChange(_ref) {
    var value = _ref.target.value;
    if (value.length > 1) {
      setActivePredefinedFilter({
        id: activePredefinedFilter.id,
        status: activePredefinedFilter.status,
        searchTerm: value
      });
    } else if (activePredefinedFilter.searchTerm) {
      setActivePredefinedFilter({
        id: activePredefinedFilter.id,
        status: activePredefinedFilter.status,
        searchTerm: ''
      });
    }
  };
  var onFilterChange = function onFilterChange(e) {
    var id = e.target.value;
    var selectedFilter = predefinedFilters.find(function (x) {
      return x.id === id;
    });
    setFilters([{
      id: selectedFilter.id,
      status: selectedFilter.status,
      searchTerm: activePredefinedFilter.searchTerm
    }]);
    setActivePredefinedFilter({
      id: selectedFilter.id,
      status: selectedFilter.status,
      searchTerm: activePredefinedFilter.searchTerm
    });
  };
  useEffect(function () {
    searchHandler(activePredefinedFilter);
  }, [activePredefinedFilter.searchTerm]);
  return /*#__PURE__*/React.createElement(StyledFlex, null, /*#__PURE__*/React.createElement(Select, {
    disabled: isLoading,
    options: predefinedFilters.map(function (filter) {
      return {
        text: t(filter.label),
        value: filter.id,
        status: filter.status
      };
    }),
    value: activePredefinedFilter.id,
    onChange: onFilterChange
  }), /*#__PURE__*/React.createElement(SearchFlex, null, /*#__PURE__*/React.createElement(TextField, {
    disabled: isLoading,
    type: "text",
    placeholder: t('field_search_label'),
    onChange: handleSearchInputChange,
    icon: "search"
  })));
};
export default Filters;